<template>
  <img
    :src="coverSrc"
    :alt="altText"
    class="comic-cover"
    loading="lazy"
    decoding="async"
  />
</template>

<script setup>
import { computed } from 'vue'
import { getOssImageUrl } from '@/shared/utils/ossImage'

const props = defineProps({
  /** 封面完整 URL（接口返回） */
  cover: {
    type: String,
    default: '',
  },
  /** 漫画名，用于 alt */
  name: {
    type: String,
    default: '',
  },
  /** OSS 缩放预设，列表卡片默认 thumb */
  preset: {
    type: String,
    default: 'thumb',
  },
})

const coverSrc = computed(() => getOssImageUrl(props.cover, /** @type {import('@/shared/utils/ossImage').OssImagePreset} */ (props.preset)))

const altText = computed(() => props.name || '漫画封面')
</script>

<style scoped src="@/shared/styles/ComicCover.css"></style>
